import React from "react";
import { Popover, Box, Paper, Typography, Grid } from "@mui/material";

interface ReplacementBoxProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  replacements: {
    replaced: string;
    replacedQty: string[];
  }[];
  showAvailable: boolean
}

export default function ReplacementBox({ anchorEl, onClose, replacements, showAvailable=false }: ReplacementBoxProps) {
  const open = Boolean(anchorEl);
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const caseUnitLabel = ConfigDictionary?.caseUnitLabel ?? "Cs";
  const packUnitLabel = ConfigDictionary?.packUnitLabel ?? "Pc";
  const otherUnitLabel = ConfigDictionary?.otherUnitLabel ?? "Oth";

  function renderQtyLabel(num: number | string, unit: string) {
    let label = unit === "cs" ? caseUnitLabel : unit === "pi" ? packUnitLabel : otherUnitLabel;
    return (
      <span style={{ fontSize: "12px", color: "#7c7c7c", display: "flex", gap: "4px" }}>
        <span style={{ maxWidth: "4ch" }}>{num}</span>
        <span>{label}</span>
      </span>
    );
  }

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "center", horizontal: "right" }}
      transformOrigin={{ vertical: "center", horizontal: "left" }}
      PaperProps={{
        sx: {
          width: 250,
          borderRadius: 3,
          border: "1px solid #E3E3E3",
          boxShadow: "0px 1px 4px rgba(135,135,135,0.16)",
          p: 2,
        },
      }}
    >
      <Typography
        sx={{
          fontWeight: 500,
          fontSize: "13px",
          color: "#00A392",
          mb: 1,
        }}
      >
        {`${showAvailable ? "Available Replacements" : "Allocated Replacements"}`}
      </Typography>

      {replacements.map((item, idx) => (
        <Paper
          key={idx}
          elevation={0}
          sx={{
            display: "flex",
            flexDirection: "column",
            borderRadius: 2,
            mb: 1.5,
            p: 1.5,
            bgcolor: "#FAFAFA",
          }}
        >
          <Typography
            variant="body1"
            fontWeight={500}
            color="#7C7C7C"
            noWrap
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              fontSize: "12px",
              mb: 0.5,
            }}
          >
            {item.replaced}
          </Typography>
          <Box sx={{ display: "flex", gap: "8px", alignItems: "center" }}>
            {item.replacedQty.map((q) => {
              const [num, unit] = q.split(" ");
              return renderQtyLabel(num, unit);
            })}
          </Box>
        </Paper>
      ))}
    </Popover>
  );
}
